import type { SupportedBrannanHeaderPhotoLayoutSchema } from '@shared/types/WebsiteHeaderSettings.types';
import type { CanOverlayStandaloneNavArgs, ShouldHideStandaloneVideoArgs } from './shouldHideStandaloneVideo.types';

/**
 * The `navBarVariant`-free half of `shouldOverlayStandaloneNav`. `navBarVariant` comes from an
 * SSR-guessed viewport check that re-resolves after hydration, so a consumer that must reserve
 * layout space before that guess is known (the hero frame's CLS-safe reserve) needs this half on
 * its own rather than waiting on the full predicate.
 */
export const canOverlayStandaloneNav = ({ isCompactView, showVideoOnlyOnWelcomePage }: CanOverlayStandaloneNavArgs): boolean =>
  isCompactView && showVideoOnlyOnWelcomePage === true;

/**
 * Whether a hidden-video header floats over the page card as a translucent bar — the single-page
 * layout's scrolled StickyNavBar look — instead of stacking above the card. Only the inline nav has
 * a bar to dress: the burger nav is a fixed button, so its hidden-video header stays as it is for
 * every couple.
 */
export const shouldOverlayStandaloneNav = (args: ShouldHideStandaloneVideoArgs): boolean => args.navBarVariant === 'inline' && canOverlayStandaloneNav(args);

/** The welcome-only opt-in exists on the two video layouts; any other blob reads as not opted in. */
export const getShowVideoOnlyOnWelcomePage = (headerPhoto: SupportedBrannanHeaderPhotoLayoutSchema): boolean | undefined =>
  headerPhoto.presentationLayout === 'videoBackground' || headerPhoto.presentationLayout === 'videoBackgroundMonogram' ? headerPhoto.showVideoOnlyOnWelcomePage : undefined;
